import {ValueObject} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {RefundReservationOpinionTransactionsValueObject} from '../ValueObjects/RefundReservationOpinionTransactionsValueObject.js'

export class RefundReservationReasonTransactionsRequest extends ValueObject {
  #reason
  #opinion

  constructor({reason, opinion}) {
    super()
    this.#reason = reason
    this.#opinion = opinion
  }

  static create({reason, opinion}) {
    return new RefundReservationReasonTransactionsRequest({
      reason: StringSharedValueObject.create({value: reason}),
      opinion: RefundReservationOpinionTransactionsValueObject.create({opinion})
    })
  }

  get reason() {
    return this.#reason.value
  }

  get opinion() {
    return this.#opinion.value
  }

  get value() {
    return {reason: this.reason, opinion: this.opinion}
  }
}
